import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ApiGetPageOptions, Page } from '@models/pages/page';
import { UserDomain } from '@models/pages/user-domains';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PagesService } from '@services/pages.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'wsb-landing-page-modal',
  templateUrl: './landing-page-modal.component.html',
  styleUrls: ['./landing-page-modal.component.scss'],
  standalone: false
})
export class LandingPageModalComponent implements OnInit {
  @Input() dateTime: string;
  @Input() sender: string;
  @Output() link: EventEmitter<any> = new EventEmitter();
  @Output() idPage: EventEmitter<any> = new EventEmitter();

  scrollPagePage = 1;
  pageList: Page[];
  domain: UserDomain[];
  page: Page;
  placeholder: string;
  scrollPagePagesTemplateList = 0;
  // selectedPage: Page;
  selectedPage = new UntypedFormControl();

  mouseDown = false;

  startY: any;

  scrollTop: any;

  slider = document.querySelector<HTMLElement>('.parent');

  constructor(public activeModal: NgbActiveModal, private pagesService: PagesService) {}

  ngOnInit(): void {
    const body = new ApiGetPageOptions();
    body.statuses = ['ONLINE'];
    this.pagesService.getPages(this.scrollPagePage, null, null, null, body).subscribe(data => {
      this.pageList = data.data;
      this.pagesService
        .getPageById(data.data[0].idPage)
        .pipe(
          map(x => {
            const newData = x;
            newData.previewHtml = x.previewHtml.replace('%HTML_TITLE_PLACEHOLDER%', '');
            return newData;
          })
        )
        .subscribe(page => {
          this.page = page;
          this.selectedPage.setValue(page.idPage);
        });
    });

    this.pagesService.getUserDomains().subscribe(domain => {
      this.domain = domain.data;
    });

    this.pagesService.getPageShortLinkPlaceholder().subscribe((placeholder: any) => {
      this.placeholder = placeholder.placeholder;
      // console.log(this.placeholder);
    });
  }

  insertCustomLink() {
    const page = this.pageList.filter(x => x.idPage === this.selectedPage.value);
    const domain = this.domain.filter(x => x.idUserDomain === page[0].idUserDomain);
    const link = this.addHttpsPrefixIfNeeded(domain[0].domain + '/' + page[0].name);
    this.link.emit(link);

    this.activeModal.dismiss();
  }

  addHttpsPrefixIfNeeded(url: string): string {
    if (!url.startsWith('https://') && !url.startsWith('http://')) {
      return `https://${url}`;
    }
    return url;
  }

  insertShortLink() {
    this.link.emit(this.placeholder);
    this.idPage.emit(this.page.idPage);
    this.activeModal.dismiss();
  }

  onSelectionChange(event) {
    this.pagesService
      .getPageById(event.idPage)
      .pipe(
        map(x => {
          const newData = x;
          newData.previewHtml = x.previewHtml.replace('%HTML_TITLE_PLACEHOLDER%', '');
          return newData;
        })
      )
      .subscribe(page => {
        this.page = page;
      });
  }

  onScrollToEnd() {
    const body = new ApiGetPageOptions();
    body.statuses = ['ONLINE'];
    this.scrollPagePage++;
    this.pagesService.getPages(this.scrollPagePage, null, null, null, body).subscribe(data => {
      this.pageList = [...this.pageList, ...data.data];
    });
  }

  startDragging(e, flag, el) {
    this.mouseDown = true;
    this.startY = e.pageY - el.offsetTop;
    this.scrollTop = el.scrollTop;
  }
  stopDragging(e, flag) {
    this.mouseDown = false;
  }
  moveEvent(e, el) {
    e.preventDefault();
    if (!this.mouseDown) {
      return;
    }
    // console.log(e, el);
    const y = e.pageY - el.offsetTop;
    const scroll = y - this.startY;
    el.scrollTop = this.scrollTop - scroll;
  }
}
